import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { me } from '../../initial_state'
import { makeGetAccount } from '../../selectors'
import { shortNumberFormat } from '../../utils/numbers'
import { openModal } from '../../actions/modal'
import {
  CX,
  MODAL_EDIT_PROFILE,
  PLACEHOLDER_MISSING_HEADER_SRC,
} from '../../constants'
import PanelLayout from './panel_layout'
import Avatar from '../avatar'
import Button from '../button'
import DisplayName from '../display_name'
import Image from '../image'
import UserStat from '../user_stat'

class SimpleUserPanel extends ImmutablePureComponent {

  state = {
    hovering: false,
  }

  updateOnProps = [
    'account'
  ]

  handleOnMouseEnter = () => {
    this.setState({ hovering: true })
  }

  handleOnMouseLeave = () => {
    this.setState({ hovering: false })
  }

  handleOnEditProfile = () => {
    this.props.onOpenEditProfile()
  }

  render() {
    const { account, onOpenEditProfile } = this.props
    const { hovering } = this.state

    const acct = account.get('acct')
    const headerSrc = !!account ? account.get('header') : undefined
    const headerMissing = !headerSrc ? true : headerSrc.indexOf(PLACEHOLDER_MISSING_HEADER_SRC) > -1

    const buttonClasses = CX({
      posAbs: 1,
      mr10: 1,
      top0: 1,
      right0: 1,
      mt10: 1,
      displayNone: !hovering,
    })

    const headerContainerClasses = CX({
      d: 1,
      h122PX: !headerMissing,
      h55PX: headerMissing,
      bgSecondary: headerMissing,
    })

    return (
      <PanelLayout key='simple-user-panel' noPadding noPanel>
        <NavLink
          className={[_s.d, _s.flexRow, _s.cursorPointer,  _s.noUnderline, _s.bgSubtle_onHover, _s.radiusSmall, _s.px5, _s.py10].join(' ')}
          to={`/${acct}`}
        >
          <div className={[_s.d, _s.circle, _s.borderColorPrimary].join(' ')}>
            <Avatar account={account} size={40} noHover />
          </div>
          <div className={[_s.d, _s.ml10].join(' ')}>
            <DisplayName account={account} isMultiline noRelationship noHover />
          </div>
        </NavLink>

        <div className={[_s.d, _s.flexRow, _s.mt5, _s.mb15, _s.pl5].join(' ')}>
          <UserStat
            // isInline
            to={`/${acct}`}
            title='Gabs'
            numvalue={account.get('statuses_count')}
            value={shortNumberFormat(account.get('statuses_count'))}
          />
          <UserStat
            // isInline
            to={`/${acct}/followers`}
            title='Followers'
            numvalue={account.get('followers_count')}
            value={shortNumberFormat(account.get('followers_count'))}
          />
          <UserStat
            // isInline
            isLast
            to={`/${acct}/following`}
            title='Following'
            numvalue={account.get('following_count')}
            value={shortNumberFormat(account.get('following_count'))}
          />
        </div>
      </PanelLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  account: makeGetAccount()(state, me),
})

const mapDispatchToProps = (dispatch) => ({
  onOpenEditProfile() {
    dispatch(openModal(MODAL_EDIT_PROFILE))
  },
})

SimpleUserPanel.propTypes = {
  account: ImmutablePropTypes.map.isRequired,
  onOpenEditProfile: PropTypes.func.isRequired,
}


export default connect(mapStateToProps, mapDispatchToProps)(SimpleUserPanel)
